import { CoreAudit } from "shared/cubiq-services/model/core/CoreAudit";
import { CoreOrderAudit } from "shared/cubiq-services/model/core/CoreOrderAudit";

/**
 * Type defining properties of an audit filter
 */
export type AuditFilter = {
  /** Does audit record belong to a BM order? */
  isBenchmark: boolean;
  /** Show audit records for trigger actions  */
  showTrigger: boolean;
  /** Show BM reval records? */
  showRevals: boolean;
  /** Show all user notifications */
  showNotifications: boolean;
  /** Show transfer audit records */
  showTransfers: boolean;
};

const LIST_OF_TRIGGER_ACTIONS: Set<string> = new Set<string>([
  "ORDACT_TRIGGERED",
  "ORDACT_FILL_TRIGGERED",
]);

const LIST_OF_NOTIFICATION_ACTIONS: Set<string> = new Set<string>([
  "ORDACT_NOTIFICATION_GENERATED",
  "ORDACT_NOTIFICATION_SENT",
  "ORDACT_NOTIFICATION_FAILED",
]);

const LIST_OF_TRANSFER_ACTIONS: Set<string> = new Set<string>([
  "ORDACT_AOC_STEAL",
  "ORDACT_AOC_EXPIRED",
  "ORDACT_AOC_ACCEPTED",
  "ORDACT_AOC_CANCELLED",
  "ORDACT_AOC_REJECTED",
  "ORDACT_AOC_XFERRED",
  "ORDACT_AOC_REQUESTED",
  "ORDACT_AOC_STEAL_REQUESTED",
  "ORDACT_AOC_STEAL_REJECTED",
]);

const LIST_OF_REVAL_ACTIONS: Set<string> = new Set<string>([
  "ORDACT_BENCHMARK_REVAL",
  "ORDACT_DAILY_BENCHMARK_REVAL",
  "ORDACT_PRE_FIXING_BENCHMARK_REVAL",
]);

/**
 * Returns true if the Audit passes the input filter
 * @param audit
 * @param filter
 * @returns
 */
export function isAuditVisible(audit: CoreOrderAudit, filter: AuditFilter): boolean {
  if (!audit?.rawAudit || !filter) {
    return false;
  }

  // Remove triggers if triggered flag is off
  if (!filter.showTrigger) {
    if (LIST_OF_TRIGGER_ACTIONS.has(audit.rawAudit.orderAction) && !filter.isBenchmark) {
      return false;
    }
  }
  if (!filter.showNotifications) {
    if (LIST_OF_NOTIFICATION_ACTIONS.has(audit.rawAudit.orderAction)) {
      return false;
    }
  }
  if (!filter.showTransfers) {
    if (LIST_OF_TRANSFER_ACTIONS.has(audit.rawAudit.orderAction)) {
      return false;
    }
  }
  if (!filter.showRevals) {
    if (LIST_OF_REVAL_ACTIONS.has(audit.rawAudit.orderAction)) {
      return false;
    }
  }
  return true;
}

export function getCommentsExport(audit: CoreAudit): string {
  return audit.comments.join("");
}
